import styled from "@emotion/styled"

const ListTwelveItem = styled.div`
  ${({ theme }) => theme.breakpoints.up("2xl")} {
    min-width: 220px;
  }
`

export default ListTwelveItem
